import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Instagram, Facebook, Phone, Mail, MapPin } from 'lucide-react';

const Footer15 = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');

    const handleSubscribe = (e) => {
        e.preventDefault();
        if (email.trim()) {
            setEmail('');
        }
    };

    const collectionsLinks = [
        { label: 'Chiffon Sarees', path: '/template15/shop' },
        { label: 'Silk Dupattas', path: '/template15/shop' },
        { label: 'Flowing Anarkalis', path: '/template15/shop' },
        { label: 'Drape Dresses', path: '/template15/shop' },
    ];

    const customerCareLinks = [
        { label: 'Contact Us', path: '/template15/contact' },
        { label: 'Shipping Policy', path: '/template15/shipping-exchange' },
        { label: 'Returns & Exchange', path: '/template15/shipping-exchange' },
        { label: 'FAQs', path: '/template15/faqs' },
        { label: 'Track Order', path: '/template15/orders' },
    ];

    const legalLinks = [
        { label: 'Terms & Conditions', path: '/template15/terms' },
        { label: 'Privacy Policy', path: '/template15/privacy-policy' },
        { label: 'About Us', path: '/template15/about' },
    ];

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@400;500;600;700&family=Nunito+Sans:wght@300;400;600&display=swap');
            `}</style>

            <footer style={{ backgroundColor: '#1E40AF' }}>
                {/* Main Footer Content */}
                <div
                    style={{
                        maxWidth: '1400px',
                        margin: '0 auto',
                        padding: '64px 24px',
                    }}
                    className="samundar-footer-main"
                >
                    <div className="samundar-footer-grid">
                        {/* Column 1: Brand */}
                        <div>
                            <h3
                                style={{
                                    fontFamily: "'Quicksand', sans-serif",
                                    fontSize: '28px',
                                    fontWeight: 700,
                                    color: '#FEFCE8',
                                    letterSpacing: '2px',
                                    margin: '0 0 12px 0',
                                }}
                            >
                                SAMUNDAR
                            </h3>
                            <p
                                style={{
                                    fontFamily: "'Nunito Sans', sans-serif",
                                    fontSize: '14px',
                                    color: 'rgba(254, 252, 232, 0.7)',
                                    lineHeight: 1.7,
                                    margin: '0 0 24px 0',
                                    fontWeight: 300,
                                }}
                            >
                                Flowing Elegance, Oceanic Grace. Celebrating the fluid beauty of Indian fashion.
                            </p>
                            <div style={{ display: 'flex', gap: '12px' }}>
                                {[Instagram, Facebook].map((Icon, i) => (
                                    <a
                                        key={i}
                                        href="#"
                                        style={{
                                            width: '40px',
                                            height: '40px',
                                            border: '1px solid rgba(254, 252, 232, 0.25)',
                                            borderRadius: '50%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#FEFCE8',
                                            transition: 'all 0.3s ease',
                                            textDecoration: 'none',
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.borderColor = '#FEFCE8';
                                            e.currentTarget.style.backgroundColor = 'rgba(254, 252, 232, 0.1)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.borderColor = 'rgba(254, 252, 232, 0.25)';
                                            e.currentTarget.style.backgroundColor = 'transparent';
                                        }}
                                    >
                                        <Icon size={18} />
                                    </a>
                                ))}
                                <a
                                    href="#"
                                    style={{
                                        width: '40px',
                                        height: '40px',
                                        border: '1px solid rgba(254, 252, 232, 0.25)',
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: '#FEFCE8',
                                        transition: 'all 0.3s ease',
                                        textDecoration: 'none',
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.borderColor = '#FEFCE8';
                                        e.currentTarget.style.backgroundColor = 'rgba(254, 252, 232, 0.1)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.borderColor = 'rgba(254, 252, 232, 0.25)';
                                        e.currentTarget.style.backgroundColor = 'transparent';
                                    }}
                                >
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M8 12a4 4 0 1 1 8 0c0 2.5-1.5 4.5-3 6l-1 3" />
                                        <path d="M12 2a10 10 0 1 0 4 19.2" />
                                    </svg>
                                </a>
                            </div>
                        </div>

                        {/* Column 2: Collections */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Quicksand', sans-serif",
                                    fontSize: '15px',
                                    fontWeight: 700,
                                    color: '#FEFCE8',
                                    letterSpacing: '1px',
                                    textTransform: 'uppercase',
                                    margin: '0 0 24px 0',
                                }}
                            >
                                Collections
                            </h4>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {collectionsLinks.map((link) => (
                                    <li key={link.label} style={{ marginBottom: '12px' }}>
                                        <span
                                            onClick={() => navigate(link.path)}
                                            style={{
                                                fontFamily: "'Nunito Sans', sans-serif",
                                                fontSize: '14px',
                                                color: 'rgba(254, 252, 232, 0.75)',
                                                cursor: 'pointer',
                                                transition: 'color 0.3s ease',
                                                textDecoration: 'none',
                                            }}
                                            onMouseEnter={(e) => (e.target.style.color = '#FEFCE8')}
                                            onMouseLeave={(e) => (e.target.style.color = 'rgba(254, 252, 232, 0.75)')}
                                        >
                                            {link.label}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Column 3: Customer Care */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Quicksand', sans-serif",
                                    fontSize: '15px',
                                    fontWeight: 700,
                                    color: '#FEFCE8',
                                    letterSpacing: '1px',
                                    textTransform: 'uppercase',
                                    margin: '0 0 24px 0',
                                }}
                            >
                                Customer Care
                            </h4>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {customerCareLinks.map((link) => (
                                    <li key={link.label} style={{ marginBottom: '12px' }}>
                                        <span
                                            onClick={() => navigate(link.path)}
                                            style={{
                                                fontFamily: "'Nunito Sans', sans-serif",
                                                fontSize: '14px',
                                                color: 'rgba(254, 252, 232, 0.75)',
                                                cursor: 'pointer',
                                                transition: 'color 0.3s ease',
                                                textDecoration: 'none',
                                            }}
                                            onMouseEnter={(e) => (e.target.style.color = '#FEFCE8')}
                                            onMouseLeave={(e) => (e.target.style.color = 'rgba(254, 252, 232, 0.75)')}
                                        >
                                            {link.label}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Column 4: Get In Touch */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Quicksand', sans-serif",
                                    fontSize: '15px',
                                    fontWeight: 700,
                                    color: '#FEFCE8',
                                    letterSpacing: '1px',
                                    textTransform: 'uppercase',
                                    margin: '0 0 24px 0',
                                }}
                            >
                                Get In Touch
                            </h4>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <Mail size={16} style={{ color: '#FEFCE8', flexShrink: 0 }} />
                                    <span style={{ fontFamily: "'Nunito Sans', sans-serif", fontSize: '14px', color: 'rgba(254, 252, 232, 0.75)' }}>
                                        hello@samundar.com
                                    </span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <Phone size={16} style={{ color: '#FEFCE8', flexShrink: 0 }} />
                                    <span style={{ fontFamily: "'Nunito Sans', sans-serif", fontSize: '14px', color: 'rgba(254, 252, 232, 0.75)' }}>
                                        +91 98765 43210
                                    </span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                    <MapPin size={16} style={{ color: '#FEFCE8', flexShrink: 0, marginTop: '2px' }} />
                                    <span style={{ fontFamily: "'Nunito Sans', sans-serif", fontSize: '14px', color: 'rgba(254, 252, 232, 0.75)', lineHeight: 1.6 }}>
                                        Mumbai, Maharashtra, India
                                    </span>
                                </div>
                            </div>

                            {/* Legal Links */}
                            <div style={{ marginTop: '24px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                {legalLinks.map((link) => (
                                    <span
                                        key={link.label}
                                        onClick={() => navigate(link.path)}
                                        style={{
                                            fontFamily: "'Nunito Sans', sans-serif",
                                            fontSize: '13px',
                                            color: 'rgba(254, 252, 232, 0.5)',
                                            cursor: 'pointer',
                                            transition: 'color 0.3s ease',
                                        }}
                                        onMouseEnter={(e) => (e.target.style.color = '#FEFCE8')}
                                        onMouseLeave={(e) => (e.target.style.color = 'rgba(254, 252, 232, 0.5)')}
                                    >
                                        {link.label}
                                    </span>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div
                    style={{
                        borderTop: '1px solid rgba(254, 252, 232, 0.15)',
                        maxWidth: '1400px',
                        margin: '0 auto',
                        padding: '24px',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            gap: '16px',
                        }}
                        className="samundar-footer-bottom"
                    >
                        <p style={{ fontFamily: "'Nunito Sans', sans-serif", fontSize: '12px', color: 'rgba(254, 252, 232, 0.5)', margin: 0 }}>
                            &copy; 2026 SAMUNDAR. All rights reserved.
                        </p>
                        <p style={{ fontFamily: "'Nunito Sans', sans-serif", fontSize: '12px', color: 'rgba(254, 252, 232, 0.5)', margin: 0, fontStyle: 'italic' }}>
                            Flowing Grace from India
                        </p>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <svg width="36" height="24" viewBox="0 0 36 24" fill="none"><rect width="36" height="24" rx="4" fill="rgba(254,252,232,0.1)" /><text x="18" y="14" textAnchor="middle" fill="rgba(254,252,232,0.6)" fontSize="8" fontWeight="bold" fontFamily="Nunito Sans, sans-serif">VISA</text></svg>
                            <svg width="36" height="24" viewBox="0 0 36 24" fill="none"><rect width="36" height="24" rx="4" fill="rgba(254,252,232,0.1)" /><circle cx="15" cy="12" r="5" fill="rgba(254,252,232,0.3)" /><circle cx="21" cy="12" r="5" fill="rgba(254,252,232,0.3)" /></svg>
                            <svg width="36" height="24" viewBox="0 0 36 24" fill="none"><rect width="36" height="24" rx="4" fill="rgba(254,252,232,0.1)" /><text x="18" y="14" textAnchor="middle" fill="rgba(254,252,232,0.6)" fontSize="7" fontWeight="bold" fontFamily="Nunito Sans, sans-serif">UPI</text></svg>
                        </div>
                    </div>
                </div>

                {/* Responsive Styles */}
                <style>{`
                    .samundar-footer-grid {
                        display: grid;
                        grid-template-columns: repeat(4, 1fr);
                        gap: 48px;
                    }
                    @media (max-width: 768px) {
                        .samundar-footer-grid {
                            grid-template-columns: 1fr;
                            gap: 40px;
                        }
                        .samundar-footer-main {
                            padding: 40px 24px !important;
                        }
                        .samundar-footer-bottom {
                            flex-direction: column;
                            align-items: center !important;
                            text-align: center;
                        }
                    }
                    @media (min-width: 769px) and (max-width: 1024px) {
                        .samundar-footer-grid {
                            grid-template-columns: repeat(2, 1fr);
                        }
                    }
                `}</style>
            </footer>
        </>
    );
};

export default Footer15;
